
import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Button, Modal, Col, Row, Form, Clearfix } from 'react-bootstrap'
import InputText from '../../../../components/commons/form/InputText'
import InputMoney from '../../../../components/commons/form/InputMoney'
import InputCheckBox from '../../../../components/commons/form/InputCheckBox'
import InputSelect from '../../../../components/commons/form/InputSelect'
import { economicPlanSectionType } from '../../../../constants/dossier/common/economicPlanSection'
import PaperworkAddress from '../../../../components/dossiers/common/paperworkAddress/PaperworkAddress'
import { validatePaperworkAddress } from '../../../../util/validationFunctions'
import { handleKeyDown } from '../../../../util/utils'

class PaperworkEditionModal extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      economicTarget: props.editedPaperwork && props.editedPaperwork.economicTarget
    }
  }

  onEconomicTargetChanges (economicTarget) {
    this.setState({ economicTarget })
  }

  submitPaperwork (values) {
    const submitValues = {
      paperworkTypeId: values.paperworkTypeId,
      cost: values.cost,
      amount: values.amount,
      processingAgencyId: values.processingAgencyId,
      comment: values.comment,
      supInvoice: values.supInvoice,
      iem: values.iem,
      toBeReviewed: values.toBeReviewed,
      economicTarget: values.economicTarget,
      provider: values.provider,
      sameEntity: values.sameEntity,
      dossierPaperworkAddressComponent: values.dossierPaperworkAddressComponent
    }

    if (values.economicTarget !== economicPlanSectionType.VENTA_OTROS) {
      submitValues.iem = null

      if (values.economicTarget !== economicPlanSectionType.SUPLIDOS) {
        submitValues.amount = null
        submitValues.supInvoice = null
      }
    }

    if (values.paperworkId) {
      this.props.actions.updatePaperwork(submitValues, values.paperworkId, this.props.dossierParentId, this.props.actions.updateDossierAction, this.props.showAlertSendPending)
    } else {
      this.props.actions.createPaperwork(submitValues, this.props.dossierParentId, this.props.actions.updateDossierAction, this.props.showAlertSendPending)
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.showModal && !nextProps.showModal) {
      this.props.initialize({})
    }
    if (!this.props.showModal && nextProps.showModal) {
      this.setState({ isDifferentPaperworkAddress: nextProps.editedPaperwork && nextProps.editedPaperwork.dossierPaperworkAddressComponent ? nextProps.editedPaperwork.dossierPaperworkAddressComponent.differentPaperworkAddress : false })
      this.props.initialize(nextProps.editedPaperwork)
    }
    if (nextProps.editedPaperwork && this.state.economicTarget !== nextProps.editedPaperwork.economicTarget) {
      this.setState({ economicTarget: nextProps.editedPaperwork.economicTarget })
    }
  }

  render () {
    const {
      t, showModal, handleSubmit, isEditionModal, showEconomicPlan,
      actions: { closePaperworkEditionModal },
      combos: { processingAgency, paperworkTypes }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.PAPERWORK.MODAL.'
    let economicTargetTypes = this.props.combos.economicTargetTypes

    economicTargetTypes = economicTargetTypes.map((economicTargetType) => {
      return { ...economicTargetType, value: t(`${tKey}ECONOMIC_PLAN_SECTION_TYPES.${economicTargetType.value}`) }
    })

    return (
      <Modal className='_nf PaperworkEditionModal' show={showModal} onHide={() => closePaperworkEditionModal()}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submitPaperwork.bind(this))} onKeyDown={(e) => handleKeyDown(e) }>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Row className='fieldsContainer'>
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="paperworkTypeId"
                name="paperworkTypeId"
                controlLabel={t(`${tKey}TYPE`)}
                placeholder={t(`${tKey}TYPE`)}
                options={paperworkTypes}
                disabled={isEditionModal}
                valueKey="id"
                labelKey="value"
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="processingAgencyId"
                name="processingAgencyId"
                controlLabel={t(`${tKey}PROCESSING_AGENCY`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY`)}
                options={processingAgency}
                valueKey="id"
                labelKey="value"
              />
              {showEconomicPlan === true && [
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="economicTarget"
                  name="economicTarget"
                  key="economicTarget"
                  controlLabel={t(`${tKey}ECONOMIC_TARGET`)}
                  placeholder={t(`${tKey}ECONOMIC_TARGET`)}
                  options={economicTargetTypes}
                  valueKey="id"
                  labelKey="value"
                  onInputChange={this.onEconomicTargetChanges.bind(this)}
                />,
                <Col sm={6} className="col-row input-group-row" key="economicPlanCheckbox">
                  {(this.state.economicTarget === economicPlanSectionType.VENTA_OTROS ||
                    this.state.economicTarget === economicPlanSectionType.SUPLIDOS) && (
                    <Field
                      component={InputCheckBox}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      id="supInvoice"
                      name="supInvoice"
                      placeholder={t(`${tKey}SUPPLEMENTARY_INVOICE`)}
                    />
                  )}
                  {this.state.economicTarget === economicPlanSectionType.VENTA_OTROS && (
                    <Field
                      component={InputCheckBox}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      id="iem"
                      name="iem"
                      placeholder={t(`${tKey}IEM`)}
                    />
                  )}
                </Col>,
                <Field
                  component={InputMoney}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="cost"
                  name="cost"
                  key="cost"
                  type="text"
                  controlLabel={t(`${tKey}COST`)}
                  placeholder={t(`${tKey}COST`)}

                />,
                (this.state.economicTarget === economicPlanSectionType.VENTA_OTROS ||
                    this.state.economicTarget === economicPlanSectionType.SUPLIDOS) && (
                  <Field
                    component={InputMoney}
                    colWidth={50} // 25, 33, 50, 75, 100 default=25
                    id="amount"
                    name="amount"
                    key="amount"
                    type="text"
                    controlLabel={t(`${tKey}AMOUNT`)}
                    placeholder={t(`${tKey}AMOUNT`)}
                  />
                )
              ]
              }
              <Clearfix />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="comment"
                name="comment"
                controlLabel={t(`${tKey}COMMENTS`)}
                placeholder={t(`${tKey}COMMENTS`)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="provider"
                name="provider"
                controlLabel={t(`${tKey}PROVIDER`)}
                placeholder={t(`${tKey}PROVIDER`)}
              />
              <Clearfix />
              {showEconomicPlan === true && (
                <Field
                  component={InputCheckBox}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="toBeReviewed"
                  name="toBeReviewed"
                  placeholder={t(`${tKey}TO_BE_REVIEWED`)}
                />
              )}
              <Field
                component={InputCheckBox}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="sameEntity"
                name="sameEntity"
                placeholder={t(`${tKey}SAME_ENTITY`)}
              />
              <Clearfix />
              <Field
                component={InputCheckBox}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="differentPaperworkAddress"
                name="dossierPaperworkAddressComponent.differentPaperworkAddress"
                placeholder={t(`${tKey}PAPERWORK_ADDRESS_DIFFERENT`)}
                onInputChange={(value) => this.setState({ isDifferentPaperworkAddress: value })}
              />
            </Row>

            {this.state.isDifferentPaperworkAddress && (
              <div className='fieldsContainer PaperworkAddress'>
                <PaperworkAddress
                  readOnlyFields={false}
                  t={t}
                  formInitRoute=""
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-C">
              <Button id="btn_save" className="_Btn new" type="submit">{t(`${tKey}SAVE_BTN`)}</Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'paperwork_edition_modal',
  validate: (values, props) => {
    const tKey = 'DOSSIER_COMPONENTS.PAPERWORK.MODAL.VALIDATION.'
    const error = {}

    error.dossierPaperworkAddressComponent = validatePaperworkAddress(values.dossierPaperworkAddressComponent ? values.dossierPaperworkAddressComponent : {}, props)
    if (!values.paperworkTypeId) error.paperworkTypeId = props.t(`${tKey}FILL_PAPERWORK_TYPE`)
    if (!values.processingAgencyId) error.processingAgencyId = props.t(`${tKey}FILL_PROCESSING_AGENCY`)
    return error
  }
})(PaperworkEditionModal)
